export function allowPageScroll() {
  document.documentElement.classList.remove('modal-opened');
}

export function preventPageScroll() {
  const scrollbarWidth =  window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  document.documentElement.classList.add('modal-opened');

}
